/**
 * @generated SignedSource<<6515383f83bf568fde7e7b1372a7cefd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueTable_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GroupTableBody_project" | "TableBody_project">;
  readonly " $fragmentType": "IssueTable_project";
};
export type IssueTable_project$key = {
  readonly " $data"?: IssueTable_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTable_project">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "isConditionalFormattingEnabled",
    "variableName": "isConditionalFormattingEnabled"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "IssueTable_project",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "GroupTableBody_project"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "TableBody_project"
    }
  ],
  "type": "JiraProject"
};
})();

(node as any).hash = "1323da9301cd486842312425cd722a4f";

export default node;
